import React from "react";
import ReactDOM from "react-dom";
import { BrickWrapper, property, UpdatingElement } from "@next-core/brick-kit";
import { FunctionDebuggerStatusbar } from "./FunctionDebuggerStatusbar";
import { ProcessedCoverage, TestStats } from "../shared/functions/interfaces";

export interface FunctionDebuggerStatusbarProps {
  coverage?: ProcessedCoverage;
  testStats?: TestStats;
}

export interface FunctionDebuggerStatusbarElementProps {
  coverage?: ProcessedCoverage;
  testStats?: TestStats;
}

/**
 * @id next-builder.function-debugger-statusbar
 * @author Steve
 * @history
 * 1.x.0: 新增构件 `next-builder.function-debugger-statusbar`
 * @docKind brick
 * @noInheritDoc
 */
export class FunctionDebuggerStatusbarElement extends UpdatingElement implements FunctionDebuggerStatusbarProps {
  @property({ attribute: false })
  coverage: ProcessedCoverage;

  @property({ attribute: false })
  testStats: TestStats;

  connectedCallback(): void {
    // Don't override user's style settings.
    // istanbul ignore else
    if (!this.style.display) {
      this.style.display = "block";
    }
    this._render();
  }

  disconnectedCallback(): void {
    ReactDOM.unmountComponentAtNode(this);
  }

  protected _render(): void {
    // istanbul ignore else
    if (this.isConnected) {
      ReactDOM.render(
        <BrickWrapper>
          <FunctionDebuggerStatusbar
            coverage={this.coverage}
            testStats={this.testStats}
          />
        </BrickWrapper>,
        this
      );
    }
  }
}

customElements.define(
  "next-builder.function-debugger-statusbar",
  FunctionDebuggerStatusbarElement
);
